
const validateBeneficiary =  (values) => {
    const errors = {};
    if(!values.name){
        errors.name = "Beneficiary Name Required"
    }
    if(!values.account){
        errors.account ="Account Number Required"
    }
    
    if(!values.bank){
        errors.bank = "Bank Name Required"
    }
    if(!values.country){
        errors.country = "Select a currency type";
    }
    if(!values.swift){
        errors.swift = "Enter Swift code"
    }
    if(!values.iban){
        errors.iban = "Enter Iban code"
    }

    return errors;
  }

export default validateBeneficiary; 